import { Loader } from '@hotjar/insights-common/services/Loader/Loader';

angular.module('hjApp.ui').service('Loader', [
    '$rootScope',
    '$timeout',
    function ($rootScope, $timeout) {
        /*********************
         * PRIVATE FUNCTIONS
         **********************/

        function showLoader(message, action, distanceFromTop) {
            $rootScope.$emit('hjLoader', message, action, distanceFromTop);
        }

        this.loader = new Loader(showLoader, (handler, delay) => $timeout(handler, delay), $timeout.cancel);
        /*********************
         * PUBLIC FUNCTIONS
         **********************/

        /**
         * Show the loader.
         *
         * @param message Message to show.
         * @param delay [optional] Delay until the loader starts to show (boolean).
         * @param distanceFromTop [optional] Distance from the top [px].
         * @param promise [optional] Promise to wait on before hiding loader
         */
        this.show = (message, delay, distanceFromTop, promise) =>
            this.loader.show({ message, delay, distanceFromTop, promise });

        /**
         * Hide the loader if it's visible.
         */
        this.hide = () => this.loader.hide();

        /**
         * Prevent the Loader spinner from displaying while `promise` is executing.
         * This suppression ends when `promise` completes or rejects.
         *
         * Usage example :
         *
         * var deferred = $q.defer();
         * Loader.suppress(deferred.promise);
         *
         * @template T
         *
         * @param {Promise<T>} promise The function or promise to suppress the loader widget.
         * @returns {Promise<T>}
         */
        this.suppress = (promise) => this.loader.suppress(promise);

        /**
         * Temporarily suppress the next loader being shown.
         *
         * Alternatively suppresses next to call to Loader.show(...) if executed without any parameter.
         *
         * Usage example:
         *
         * Loader.suppressOnce();
         */
        this.suppressOnce = () => this.loader.suppressOnce();
    }
]);
